import React, { useState } from 'react';
import { Stethoscope, User, Shield, MessageCircle } from 'lucide-react';
import apiService from '../services/apiService';
import { setStoredAuth } from '../utils/auth';

const LoginScreen = ({ onLogin }) => {
  const [mode, setMode] = useState('user');
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleUserEnter = async () => {
    setError('');
    setLoading(true);
    try {
      const data = await apiService.login('user', '', 'user');
      setStoredAuth({ token: data.token, role: data.role });
      onLogin(data.role);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAdminEnter = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await apiService.login(username, password);
      setStoredAuth({ token: data.token, role: data.role });
      onLogin(data.role);
    } catch (err) {
      setError(err.message || 'Yönetici şifresi hatalı.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen text-slate-200" style={{ background: 'var(--bg-app)' }}>
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 -z-10"
        style={{
          background:
            'radial-gradient(ellipse 70% 50% at 20% 30%, rgba(13,148,136,0.15) 0%, transparent 50%), var(--bg-app)',
        }}
      />

      <div className="flex w-full flex-col lg:flex-row">
        <div className="relative flex flex-1 flex-col items-center justify-center px-8 py-12 lg:px-16">
          <div className="relative w-full max-w-md">
            <div className="relative rounded-2xl border border-white/10 bg-white/[0.03] p-6 backdrop-blur-xl">
              <div className="mb-4 flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-teal-600">
                  <Stethoscope className="h-5 w-5 text-white" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-white">Özel Aktif International Hospital</p>
                  <p className="text-xs text-slate-400">Kocaeli · Ses + Sosyal AI Platform</p>
                </div>
              </div>
              <ul className="space-y-2 text-sm text-slate-400">
                <li className="flex items-center gap-2"><Stethoscope className="h-4 w-4 text-teal-400" /> Sesli randevu asistanı</li>
                <li className="flex items-center gap-2"><MessageCircle className="h-4 w-4 text-teal-400" /> Facebook / Instagram kampanya asistanı</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-1 items-center justify-center px-6 py-12 lg:px-12">
          <div className="w-full max-w-md rounded-2xl border border-white/10 bg-white/[0.04] p-8 backdrop-blur-xl">
            <h2 className="text-xl font-semibold text-white">Panele Giriş</h2>
            <p className="mt-1 text-sm text-slate-400">Hastane operasyon paneline erişim</p>

            <div className="mt-6 flex rounded-xl bg-white/[0.04] p-1 ring-1 ring-white/10">
              <button
                type="button"
                onClick={() => { setMode('user'); setError(''); }}
                className={`flex flex-1 items-center justify-center gap-2 rounded-lg py-2.5 text-sm font-medium ${
                  mode === 'user' ? 'bg-teal-500/15 text-teal-200' : 'text-slate-400'
                }`}
              >
                <User className="h-4 w-4" /> Kullanıcı
              </button>
              <button
                type="button"
                onClick={() => { setMode('admin'); setError(''); }}
                className={`flex flex-1 items-center justify-center gap-2 rounded-lg py-2.5 text-sm font-medium ${
                  mode === 'admin' ? 'bg-teal-500/15 text-teal-200' : 'text-slate-400'
                }`}
              >
                <Shield className="h-4 w-4" /> Yönetici
              </button>
            </div>

            {mode === 'user' ? (
              <div className="mt-6">
                <p className="text-sm text-slate-400">Standart kullanıcı girişi — şifre gerekmez.</p>
                <button type="button" onClick={handleUserEnter} disabled={loading} className="btn-primary mt-6 w-full">
                  {loading ? 'Giriş…' : 'Panele Gir'}
                </button>
              </div>
            ) : (
              <form onSubmit={handleAdminEnter} className="mt-6 space-y-4">
                <div>
                  <label className="field-label">Kullanıcı adı</label>
                  <input className="field w-full" value={username} onChange={(e) => setUsername(e.target.value)} />
                </div>
                <div>
                  <label className="field-label">Şifre</label>
                  <input
                    type="password"
                    className="field w-full"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                  />
                </div>
                {error && <p className="text-sm text-rose-400">{error}</p>}
                <button type="submit" disabled={loading} className="btn-primary w-full">
                  {loading ? 'Giriş…' : 'Yönetici Olarak Gir'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
